// this is an autogenerated file from DesignSystem/TasksFilters/Stage/Content/Stages/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksFilters_Stage_Content_Stages($board_ids: [uuid!]!) {
  tasks_stages(
    where: { board_id: { _in: $board_ids } }
    order_by: { order: asc }
  ) {
    id
    name
    board {
      id
      name
    }
  }
}

`